import './App.css';
import React, { useEffect, useMemo, useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useSelector } from 'react-redux';
import { getDesignTokens } from './components/drakLiteDesign';
import DrawerAppBar from './components/MenuBar';
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
} from "react-router-dom";
import Home from './pages/Home';
import AthkarEsabah from './pages/athkarESabah';
import AthkarElMasaa from './pages/athkarElmasaa';
import AthkarElnom from './pages/athkarElnom';
import AthkarEsalah from './pages/athkarEsalah';
import Error from './pages/error';
import ScrollButton from './components/scrollToTopBtn';
import WerdAlthekr from './pages/werdAlthekr';
import AlathkarAmudafa from './pages/AlathkarAlmudafa';




const AppLayout = () =>{
  return(
    <>
    <DrawerAppBar/> 
    <Outlet/>
    <ScrollButton/>
    </>
  )
}

const router = createBrowserRouter([
  {
   
      element:<AppLayout/>  ,
      errorElement: <Error/>,
      children:[
{
  path:"/",
  element:<Home/> 
},
{
  path:"athkarEsabah",
  element:<AthkarEsabah/> 
},
{
  path:"athkarElmasaa",
  element:<AthkarElMasaa/> 
},
{
  path:"athkarElnom",
  element:<AthkarElnom/> 
}
,
{
  path:"athkarEsalah",
  element:<AthkarEsalah/> 
},
{
  path:"werdAlthekr",
  element:<WerdAlthekr/> 
},
{
  path:"AlathkarAlmudafa",
  element:<AlathkarAmudafa/>
}
      ]
 
  },
 
]);

function App() {

  const [mode, setMode] = useState("light");
  const darkMode = useSelector((state) => state.theme.darkMode);
  useMemo(() => {
    if (darkMode) {
      setMode("dark");
    } else {
      setMode("light");
    }
  }, [darkMode]);

  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  useEffect(() => {
    // Update CSS variable for body background color based on theme
    document.body.style.setProperty('--body-background-color', theme.palette.background.default);

  }, [theme]);
  return (

    <ThemeProvider  theme={theme}>
    <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
